
import Vue from "vue";
import RULES from "@/mixins/rules";
import EventBus from "@/plugins/event-bus";
import { Establecimiento } from "@/models/Establecimiento";
import EstablecimientoService from "@/services/EstablecimientoService";
import NuevaConstanciaUsoSueloService from "@/services/NuevaConstanciaUsoSueloService";
import Direccion from "@/components/Beneficiarios/Direccion.vue";
import { Domicilio } from "@/models/Domicilio";

export default Vue.extend({
  name: 'NuevaConstanciaUsoSuelo',
  mixins: [RULES],
  directives: {},
  components: {
    Direccion
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    locacion: {
      type: Number,
      default: 0
    },
  },
  data: () => ({
    formData: {
      ...new Establecimiento(),
    },
    actividades: [] as any,
    actividades_secundarias: [] as any[],
    handleEsc: null as ((e: KeyboardEvent) => void) | null,
  }),
  created() {
  },
  async mounted() {
    await EstablecimientoService.getActividades().then((response) => {
      this.actividades = response.data;
    });
    await EstablecimientoService.getActividadesSecundarias().then((response) => {
      this.actividades_secundarias = response.data;
    });
    this.handleEsc = (e) => {
      if (e.key === "Escape") {
        this.close(false);
      }
    };
    document.addEventListener("keydown", this.handleEsc);
  },
  computed: {},
  watch: {
  },
  methods: {
    beforeDestroy() {
      if (this.handleEsc) {
        document.removeEventListener("keydown", this.handleEsc);
      }
    },
    enviarRevision() {
      EventBus.$emit("update-direccion");
      NuevaConstanciaUsoSueloService.setNuevaConstanciaUsoSuelo(this.formData, this.locacion).then((response) => {
        if (response.data.success) {
          this.$toast.success('Constancia de uso de suelo solicitada exitosamente');
          this.close(true);
        }else{
          this.$toast.error(response.data.message);
        }
      })
    },
    setDomicilio(domicilio: Domicilio) {
      //console.log(this.formData.domicilio)
      this.formData.domicilio = Object.assign({}, domicilio);
    },
    close(refresh: boolean) {
      EventBus.$emit("close-nueva-constancia-uso-suelo");
      if (refresh) {
        EventBus.$emit("update-registers");
      }
    },
  }
});

